import { Case, CaseElse, If, Switch } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { Box, IconButton, Link, Stack, Tooltip, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { ScheduleSummary } from "routes/schedule/plugins/ai-summary/ai-summary.runtime"
import { emptyArray } from "routes/asset-register/plugins/asset-mapping/empty-array"
import { ListItemBox } from "lib/@components/ListItemBox"
import { ScheduleLabel } from "routes/asset-register/plugins/asset-mapping/schedule-label"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useTreeItem } from "routes/schedule/lib/useTreeItem.js"

export function MappingStatus({ baseSchedules, item, onClick, treeItem, isMapping }) {
    const {
        isManualMapTab,
        chosenSchedule,
        firstManuallySelectedScheduleId,
        manuallySelectedCount: customCount,
        manuallySelectedSchedulesCombined: manuallySelectedScheduleIds,
        onExpandAssetRow,
    } = useBoundContext()
    const firstManualSelectedSchedule = useTreeItem(firstManuallySelectedScheduleId)
    const manualSelectedRemainder = (manuallySelectedScheduleIds ?? emptyArray).length - 1
    const intelligentSelectedRemainder = (baseSchedules ?? emptyArray).filter((schedule) => schedule?.chosen).length - 1

    return (
        <If truthy={isMapping && !item.doNotMap}>
            <Typography variant="body2" color="error.main" sx={{ fontWeight: "bold" }}>
                Not Mapped
            </Typography>
            <Else>
                <Switch value={item.doNotMap}>
                    <Case when="create">
                        <If truthy={customCount > 0}>
                            <If truthy={!!firstManualSelectedSchedule?.label}>
                                <Stack direction="row" alignItems="center">
                                    <Box mr={1}>
                                        <ScheduleLabel
                                            label={firstManualSelectedSchedule?.label}
                                            code={firstManualSelectedSchedule?.code}
                                        />
                                    </Box>

                                    <If truthy={!firstManualSelectedSchedule?.notLicensed}>
                                        <Tooltip title="Preview this schedule" arrow>
                                            <IconButton
                                                onClick={onClick}
                                                color="primary"
                                                size="small"
                                                aria-label={`Preview the ${firstManualSelectedSchedule?.label} schedule`}
                                                data-cy={`mapped-schedule-preview-${firstManuallySelectedScheduleId}`}
                                            >
                                                <Iconify icon="mdi:eye" />
                                            </IconButton>
                                        </Tooltip>
                                        <ScheduleSummary
                                            id={firstManuallySelectedScheduleId}
                                            label={firstManualSelectedSchedule?.label}
                                        />
                                    </If>
                                    <If truthy={manualSelectedRemainder > 0}>
                                        <Link
                                            component="button"
                                            type="button"
                                            sx={{ cursor: "pointer", ml: 1 }}
                                            onClick={onExpandAssetRow}
                                        >
                                            +{manualSelectedRemainder} more
                                        </Link>
                                    </If>
                                </Stack>
                                <Else>
                                    <ListItemBox spacing={1}>
                                        <Box>{customCount} Selected Schedules</Box>
                                    </ListItemBox>
                                </Else>
                            </If>

                            <Else>
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <Typography variant="body2" color="error.main" sx={{ fontWeight: "bold" }}>
                                        {isManualMapTab ? "Not Mapped" : "Unmapped Custom Schedule"}
                                    </Typography>
                                </Stack>
                            </Else>
                        </If>
                    </Case>
                    <Case when="nothing">
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <Iconify icon="pepicons-pop:no-entry" />
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: "bold" }}>
                                Excluded
                            </Typography>
                        </Stack>
                    </Case>
                    {baseSchedules !== emptyArray && (
                        <CaseElse>
                            <If truthy={chosenSchedule}>
                                <Stack direction="row" alignItems="center">
                                    <Box mr={1}>
                                        <ScheduleLabel label={treeItem?.label} code={treeItem?.code} />
                                    </Box>
                                    {!treeItem?.notLicensed && (
                                        <Tooltip title="Preview this schedule" arrow>
                                            <IconButton
                                                onClick={onClick}
                                                color="primary"
                                                size="small"
                                                aria-label={`Preview the ${treeItem?.label} schedule`}
                                                data-cy={`mapped-schedule-preview-${chosenSchedule?.schedule_id}`}
                                            >
                                                <Iconify icon="mdi:eye" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    <ScheduleSummary id={chosenSchedule?.schedule_id} label={treeItem?.label} />
                                    <If truthy={intelligentSelectedRemainder > 0}>
                                        <Link
                                            component="button"
                                            type="button"
                                            sx={{ cursor: "pointer", ml: 1 }}
                                            onClick={onExpandAssetRow}
                                        >
                                            +{intelligentSelectedRemainder} more
                                        </Link>
                                    </If>
                                </Stack>
                                <Else>
                                    <Typography variant="body2" color="error.main" sx={{ fontWeight: "bold" }}>
                                        Not Mapped
                                    </Typography>
                                </Else>
                            </If>
                        </CaseElse>
                    )}
                </Switch>
            </Else>
        </If>
    )
}
